export const PRODUCTS = [
  {
    id: 1,
    name: "Les Ailes d'Ange",
    subtitle: 'Signature Angel Ring',
    price: '22.500 €',
    priceValue: 22500,
    category: 'rings',
    material: 'Sterling Silber & 18K Gold',
    featured: true,
    image: '/assets/PXL_20260329_064714711.jpg',
    description:
      'Das exklusive Meisterstück – handgefertigte Engelsflügel aus Sterling Silber mit 18K Gold-Akzent. Ein Symbol für Schutz und himmlische Eleganz.',
    gallery: [
      {
        type: 'image',
        url: '/assets/PXL_20260329_064714711.jpg',
      },
      {
        type: 'image',
        url: '/assets/grok-image-11112b3d.png',
      },
      {
        type: 'image',
        url: '/assets/grok-image-f13ba83c.png',
      },
      {
        type: 'video',
        url: '/assets/grok-video-587b68e7.mp4',
      },
    ],
  },
  {
    id: 2,
    name: 'Collier Infini cœur',
    subtitle: 'Infinite Heart Necklace',
    price: '16.900 €',
    priceValue: 16900,
    category: 'necklaces',
    material: '18K Gold & Saphire',
    featured: true,
    image: '/assets/PXL_20260329_092814300.jpg',
    description:
      'Das Collier des unendlichen Herzens – ein majestätisches Statement-Collier aus 18K Gold mit blauen Saphiren. Verbindet zeitlose Liebe mit unendlicher Eleganz.',
    gallery: [
      {
        type: 'image',
        url: '/assets/PXL_20260329_092814300.jpg',
      },
      {
        type: 'image',
        url: '/assets/grok-image-09e98175.png',
      },
      {
        type: 'image',
        url: '/assets/grok-image-306cdc1d.png',
      },
      {
        type: 'video',
        url: '/assets/grok-video-306cdc1d.mp4',
      },
    ],
  },
  {
    id: 3,
    name: 'Anneau du démon',
    subtitle: 'The Demon Ring',
    price: '19.500 €',
    priceValue: 19500,
    category: 'rings',
    material: 'Geschwärztes Sterling Silber',
    featured: true,
    image: '/assets/PXL_20260329_092616320.jpg',
    description:
      'Der Dämonenring – ein kraftvolles Statement aus geschwärztem Sterling Silber. Die dunkle Seite des Luxus, wo Eleganz auf mystische Macht trifft.',
    gallery: [
      {
        type: 'image',
        url: '/assets/PXL_20260329_092616320.jpg',
      },
      {
        type: 'image',
        url: '/assets/grok-image-8bc13942.png',
      },
      {
        type: 'image',
        url: '/assets/grok-image-57b232c3.png',
      },
      {
        type: 'video',
        url: '/assets/grok-video-9cab6c3b.mp4',
      },
    ],
  },
  {
    id: 4,
    name: "Bracelet de l'infini",
    subtitle: 'The Infinity Bracelet',
    price: '14.800 €',
    priceValue: 14800,
    category: 'bracelets',
    material: 'Vergoldetes Sterling Silber',
    featured: true,
    image: '/assets/PXL_20260329_092604344.jpg',
    description:
      'Das Unendlichkeitsarmband – ein elegantes Statement aus vergoldetem Sterling Silber. Symbolisiert ewige Verbindung und zeitlose Eleganz. "Good Luck - Wherever you go, may luck and love follow."',
    gallery: [
      {
        type: 'image',
        url: '/assets/PXL_20260329_092604344.jpg',
      },
      {
        type: 'image',
        url: '/assets/grok-image-01615741.png',
      },
      {
        type: 'image',
        url: '/assets/grok-image-d7dee61e.png',
      },
      {
        type: 'video',
        url: '/assets/grok-video-47115dfc.mp4',
      },
    ],
  },
];
